import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../../utils/translator.helper';
import { FontSizes } from '../../../../types/common/types';

/**
 * @summary Type here the description of this component
 * @tag gz-sso-single-integration-widget
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-sso-single-integration-widget')
export class SsoSingleIntegrationWebComponent extends LitElement {
  @property({ type: Boolean, reflect: true })
  isProvisioned = false;

  @property({ type: String, reflect: true })
  featureId: string;

  @property({ type: String, reflect: true })
  icon: string;

  @property({ type: String, reflect: true })
  heading: string;

  @property({ type: String, reflect: true })
  description: string;

  @property({ type: String, reflect: true })
  supportUrl: string;

  static get styles() {
    return styles;
  }

  getEventType(provisionStatus: boolean): string {
    return provisionStatus ? `open-console-${this.featureId}` : `go-to-feature-${this.featureId}`;
  }

  render() {
    return html`
      <div class="single-integration-banner">
        <div class="image-container">
          <img src="app/webcomponents/assets/images/landingPage/integration.svg" />
          <div class="icon">
            <gz-icon name="${this.icon}" size="48"></gz-icon>
          </div>
        </div>
        <div class="data-container">
          <gz-title id="${this.featureId}-title" class="mb-2 header-title" fontSize="${FontSizes.TITLE}"
            >${this.heading}</gz-title
          >
          <gz-text id="${this.featureId}-description" class="fs-14"> ${this.description} </gz-text>
          <div class="btns-container mt-3">
            <gz-button
              id="${this.featureId}-action-button"
              class="feature-btn mr-2"
              type="full"
              color="primary"
              theme="light"
              buttonHeight="medium"
              buttonFontSize="medium"
              @click="${() => this.featureBtnAction(this.getEventType(this.isProvisioned))}"
              buttonFontSize="medium"
            >
              ${this.isProvisioned ? translateFn('Open Console') : translateFn('Go to Feature')}
            </gz-button>
            <gz-button
              id="${this.featureId}-support-button"
              class="suport-center"
              type="outline"
              color="secondary"
              theme="dark"
              buttonHeight="medium"
              buttonFontSize="medium"
              @click="${() => window.open(this.supportUrl, '_blank')}"
            >
              ${translateFn('Support Center')}
            </gz-button>
          </div>
        </div>
      </div>
    `;
  }

  private featureBtnAction(event: string): void {
    this.dispatchEvent(
      new Event(event, {
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-sso-single-integration-widget': SsoSingleIntegrationWebComponent;
  }
}
